import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { LOGO } from "../../lib/images";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      signIn(data.access_token, data.user);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-hb-surface border border-hb-line text-hb-cream px-4 py-3 outline-none focus:border-hb-brass transition-colors";

  return (
    <div className="min-h-screen bg-hb-black flex items-center justify-center px-5 relative grain">
      <form onSubmit={submit} className="relative z-10 w-full max-w-md border border-hb-line p-10 bg-hb-surface/40" data-testid="admin-login-form">
        <img src={LOGO} alt="Hackberry Home" className="h-16 w-16 object-contain logo-invert mx-auto mb-6" />
        <h1 className="font-serif text-3xl text-hb-cream text-center mb-1">Kitchen Dashboard</h1>
        <p className="eyebrow text-hb-brass text-[0.6rem] text-center mb-8">Staff Login</p>
        {error && <p className="text-red-400 text-sm mb-4 text-center" data-testid="admin-login-error">{error}</p>}
        <div className="space-y-4">
          <div>
            <label className="eyebrow text-hb-muted text-[0.6rem] block mb-2">Email</label>
            <input type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required />
          </div>
          <div>
            <label className="eyebrow text-hb-muted text-[0.6rem] block mb-2">Password</label>
            <input type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required />
          </div>
        </div>
        <button type="submit" disabled={loading} className="btn-brass eyebrow w-full py-4 mt-8 disabled:opacity-60" data-testid="admin-login-submit">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
